import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-hpfc-skeleton',
  imports: [Skeleton],
  templateUrl: './dashboard-hpfc-skeleton.html',
})
export class DashboardHpfcSkeleton {}
